import { AsyncDirective } from "lit/async-directive.js";
import { tooltipDirectiveCss, positionTooltip, getMaxTextWidth } from "./omni-tooltip-shared.js";
import { directive } from "lit/directive.js";
class TooltipDirective extends AsyncDirective {
  constructor() {
    super(...arguments);
    this.place = "top";
    this.message = "";
    this.tooltipElement = null;
    this.parentElement = null;
    this.disabled = false;
    this.#showTooltip = () => {
      if (positionTooltip(this.parentElement, this.tooltipElement, this.place, this.message)) {
        window.addEventListener("scroll", this.#hideTooltip);
        this.tooltipElement.showPopover();
      }
    };
    this.#hideTooltip = () => {
      window.removeEventListener("scroll", this.#hideTooltip);
      this.tooltipElement.hidePopover();
    };
  }
  update(part, [message = null, config = { place: "top", disabled: false }] = []) {
    this.parentElement = part.element;
    this.disabled = config.disabled;
    if (this.disabled) return;
    setTimeout(() => {
      if (message) {
        this.#addEventListeners();
        this.place = config.place;
        this.message = message;
        this.#insertTooltipElement();
      } else {
        const computedStyle = getComputedStyle(this.parentElement);
        if (computedStyle.width && computedStyle.width !== "auto") {
          const innerText = this.parentElement.innerText.trim();
          const totalPadding = parseInt(computedStyle.paddingLeft) + parseInt(computedStyle.paddingRight);
          const totalWidth = parseInt(computedStyle.width);
          const obj = getMaxTextWidth(innerText.split(""), totalWidth - totalPadding);
          if (!obj.isOverflow) return;
          this.#addEventListeners();
          this.message = innerText;
          this.parentElement.innerHTML = obj.str;
          this.#insertTooltipElement();
        }
      }
    }, 0);
  }
  #addEventListeners() {
    this.parentElement.addEventListener("mouseover", this.#showTooltip);
    this.parentElement.addEventListener("focusin", this.#showTooltip);
    this.parentElement.addEventListener("mouseout", (e) => {
      const target = e.target;
      const relatedTarget = e.relatedTarget;
      if (this.parentElement.contains(target) && !this.parentElement.contains(relatedTarget)) {
        this.#hideTooltip();
      }
    });
    this.parentElement.addEventListener("focusout", this.#hideTooltip);
  }
  #insertTooltipElement() {
    const checkStyleElement = document.getElementById("tooltip-style");
    let styleElement = null;
    if (!checkStyleElement) {
      styleElement = this.createStyleElement();
      document.body.appendChild(styleElement);
    } else {
      styleElement = checkStyleElement;
    }
    const checkTooltipElement = document.getElementById("popover-container");
    if (checkTooltipElement) {
      this.tooltipElement = checkTooltipElement;
    } else {
      this.tooltipElement = this.createTooltipElement();
    }
    styleElement.after(this.tooltipElement);
  }
  createStyleElement() {
    const styleEle = document.createElement("style");
    styleEle.innerHTML = tooltipDirectiveCss.toString();
    styleEle.id = "tooltip-style";
    return styleEle;
  }
  createTooltipElement() {
    const tooltipEle = document.createElement("div");
    tooltipEle.id = "popover-container";
    tooltipEle.setAttribute("popover", "");
    tooltipEle.innerHTML = `
      <div id="tooltip-container">
        <div id="tooltip-arrow" part="arrow" .position=${this.place}></div>
        <p style="margin: 0;">${this.message}</p>
      </div>
    `;
    return tooltipEle;
  }
  #showTooltip;
  #hideTooltip;
  disconnected() {
    this.parentElement.removeEventListener("mouseover", this.#showTooltip);
    this.parentElement.removeEventListener("focusin", this.#showTooltip);
    this.parentElement.removeEventListener("mouseout", this.#hideTooltip);
    this.parentElement.removeEventListener("focusout", this.#hideTooltip);
  }
  render() {
    return null;
  }
}
const tooltip = directive(TooltipDirective);
export {
  tooltip
};
//# sourceMappingURL=omni-tooltip-directive.js.map
